/**
 * [state 状态]
 * userData 用户数据
 * 
 * [actions 事件派发]
 * SET_USERDATA 改变状态中的用户数据]
 * 
 * [mutations 状态变更]
 */
const storeData = {
}

export default {
  state: {
    createMeetingData: {}
  },
  mutations: {
    set_createMeetingData(state, val) {
      state.createMeetingData = val
    },
  },
  actions: {}
}


// WEBPACK FOOTER //
// ./src/store/meeting.js